import { action, computed, observable, makeObservable } from 'mobx';
import {logger} from '../../../lib/helpers';
import {ClassroomState} from '../models/classroom-models';

export class ClassroomStateStore {
  @observable
  classroomState: ClassroomState | null;

  constructor() {
    makeObservable(this);
    this.classroomState = null;
  }

  @computed
  get currentPageId(): number | null {
    return this.classroomState === null
      ? null
      : this.classroomState.CurrentPageId;
  }

  @computed
  get currentPushableBlockId(): number | null {
    return this.classroomState === null
      ? null
      : this.classroomState.CurrentPushableBlockId;
  }

  @action
  updateClassroomState = (classroomState: ClassroomState) => {
    const next = classroomState;
    // noinspection SuspiciousTypeOfGuard
    if (next === null ||
      next === undefined ||
      typeof next !== 'object' ||
      typeof next.Version !== 'number') {
      logger.error('ClassroomHubStore.updateState', 'unexpected value for state', next);
      return;
    }
    let current = this.classroomState;
    if (current === null)
      this.classroomState = next;
    else if (current.Version <= next.Version)
      this.classroomState = next;
    else
      logger.log('ClassroomHubStore: stale version', 'current=', current, 'received=', next);
  };

  @action
  clearClassroomState = () => {
    this.classroomState = null;
  };
}

